import { useState, useEffect } from "react";
import { displayDate } from "../../../utils/masks";
import Modal from "../../../components/modal";
import api from "../../../services/api";

interface Params {
  memberChanged: any;
  memberCurrent?: any;
  idMember: number;
  open: boolean;
  afterCloseModal: any;
}

export default function AuditDetail(props: Params) {
  const { memberChanged, memberCurrent, open, afterCloseModal, idMember } = props;

  const [modalIsOpen, setModelOpen] = useState<boolean>(false);
  const [changeMember, setChangeMember] = useState({} as any);
  const [currentMember, setCurrentMember] = useState({} as any);

  useEffect(() => {
    setModelOpen(open);
    if (memberChanged) {
      setChangeMember(JSON.parse(memberChanged));
      setCurrentMember(memberCurrent);
    }
  }, [memberChanged, open]);

  useEffect(()=> {
    const initMember = async () => {
      setChangeMember(undefined);
      if (idMember > 0) {
        const { data } = await api.get(`members/${idMember}`);

        setCurrentMember(data.item);
        setChangeMember(JSON.parse(memberChanged));
      }
    }
    initMember();
  }, [idMember]);

  const closeModal = () => {
    handleCloseModal();
    afterCloseModal();
  };

  const handleCloseModal = () => {
    setModelOpen(false);
    setChangeMember({});
    afterCloseModal();
  };

  const handleFields = () => {
    if (!changeMember) return;
    return (
      <div className="uk-overflow-auto">
        <table className="uk-table uk-table-divider uk-table-striped uk-table-hover uk-table-justify uk-table-responsive">
          <thead>
            <th>Campo</th>
            <th>Valor Anterior</th>
            <th>Valor Atual</th>
          </thead>
          <tbody>
            {
              Object.keys(changeMember).map((objKey) => {
                return <tr>{customFields(objKey)}</tr>;
              })
            }
          </tbody>
        </table>
      </div>
    );
  }

  const fieldsDisplay = {
    'baptismDate': 'Data Batismo',
    'since': 'Membro Desde',
    'birthDate': 'Nascimento',
    'cardNumber': "Nº Carteirinha",
    'ecclesiasticalFunction': "Função Eclesiástica",
    'congregation': "Congregação",
    'name': "Nome",
    'gender': "Sexo",
    'document': "CPF",
    'register': "RG",
    'stateBirth': "Estado Nasc.",
    'cityBirth': "Cidade Natal",
    'motherName': "Nome da Mãe",
    'fatherName': "Nome do Pai",
    'maritalStatus': "Estado Civil",
    'lifePartnerName': "Cônjuge",
    'baptismSpiritDate': "Data Batismo Espírito Santo",
    'zipCode': "CEP",
    'address': "Endereço",
    'numberAddress': "Número",
    'addressLine2': "Complemento",
    'neighborhood': "Bairro",
    'phone': "Telefone",
    'state': "Estado",
    'city': "Cidade",
    'email': "E-mail",
    'photo': "Foto",
    'note': "Observações"
  } as any;

  interface IField {
    display: any;
    previous: any;
    current: any;
  }

  const customFields = (objkey: any) => {
    const field = {} as IField;
    field.display = fieldsDisplay[objkey];

    if (!field.display) return;

    if (['baptismDate', 'since', 'birthDate', 'baptismSpiritDate'].indexOf(objkey) > -1)
    {
      field.previous = displayDate(changeMember[objkey]);
      field.current = displayDate(currentMember[objkey]);
    } else {
      field.previous = changeMember[objkey];

      if (['congregation', 'ecclesiasticalFunction'].indexOf(objkey) > -1) {
        field.current = currentMember[objkey].description;
      } else {
        field.current = currentMember[objkey];
      }
    }
    
    return <>
      <td>{field.display}</td>
      <td>
        {field.display == 'Foto' ? fieldPhoto(field.previous) : field.previous}
      </td>
      <td>
        {field.display == 'Foto' ? fieldPhoto(field.current) : field.current}
      </td>
    </>
  }

  const fieldPhoto = (photo: string) => {
    if (!photo) return '';
    if (photo?.indexOf('FOTO ADICIONADA') >= 0) return photo;
    return <img width={50} height={50} src={`data:image/jpeg;base64,${photo}`}></img>;
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className="modal-small"
      shouldCloseOnOverlayClick={false}
    >
      <div className="uk-modal-header">
        <h2 className="uk-modal-title">Alterações Realizadas</h2>
      </div>
      <button
        className="uk-modal-close-default"
        uk-close="true"
        type="button"
        onClick={handleCloseModal}
      />
      <div className="uk-modal-body">
        {
          !changeMember ? <div className="uk-flex uk-flex-center">
            <div uk-spinner="true; ratio:2">Carregando...</div>
          </div> :
          !changeMember && <div>Nenhuma Alteração Realizada</div>
        }
        {handleFields()}
      </div>
    </Modal>
  );
}
